import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, subscrib, queryHistory } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Main = Loadable({
    loader: () => import('./Main'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          smartCodeServiceMainState: state.smartCodeServiceMainState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          subscrib,
          queryHistory,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/main`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Main {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
